// Check if we're in production or if a custom API URL is provided
const getServerBaseUrl = (): string => {
  // Check for custom environment variable first
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Check if we're in production (served over HTTPS)
  if (window.location.protocol === 'https:') {
    // Use HTTPS for the API in production
    return `https://${window.location.hostname}/api`;
  }
  
  // Default to local development
  return "http://localhost:3006";
};

const SERVER_BASE_URL = getServerBaseUrl();

export { SERVER_BASE_URL };